

import { ReceptionType } from "../../constants/ReceptionType";
import { ProtocolMeta } from "../../protocol-configuration/dto/Protocol";
import { LabMDM } from "./lab";

export class ProjectWorkflow{
    workFlowID:string;
    workflowName: string;
    lab: LabMDM;
    projectId: string;
    identifiers: Identifier[];
    receptionType: ReceptionType;
    automatedReception = false;
    qcScan = false;
    plateMerge = false;
    storageTemperature: string;
    buffer: string;
    tat: Map<any,any>;
    samplesHaveBarcodes = false;
    arrayPartNumber: string;
    illuminaPackageCode: string;
    arrayName: string;
    upstream: ProtocolMeta[];
    downstream: ProtocolMeta[];
    aliquotVolume: string;
    active = true;
  }

  export class Identifier{
    name: string;
    values: string[];
  }
